import { Pipe, PipeTransform } from '@angular/core';
import { gfToDateFunction } from './date.functions';

@Pipe({
    name: 'gfToDate'
})
export class DateGfToDatePipe implements PipeTransform {
    transform(inputValue?: any, locale?: string): any {
        return gfToDateFunction(inputValue, locale);
    }
};